<template>
  <Validator label="" :v="v" input>
    <div class="custom-input" ref="selectLista">
      <div
        :class="{
          'outline-block': true,
          'outline-block--focus': inputFocus,
          'outline-border-error': v.$invalid && v.$dirty || validation
        }">
        <div
          @click="onClick"
          style="height: 52px"
          :class="{ 'outline-border-error': (v.$invalid && v.$dirty) || validation, 'outline-input outline-input-select': true, 'outline-input-disabled': disabled }">
          {{ descricaoValue }}
        </div>
        <input
          type="text"
          ref="input"
          class="input-custom-rows"
          :disabled="disabled"
          readonly
          @focus="onFocus"
          @blur="onBlur"
          @keyup="onKeyUp"
          @change="onChange" />
        <div
          :class="{
            'outline-label' : true,
            'outline-label-up': (descricaoValue !== ''),
            'outline--focus': inputFocus,
            'outline-error': v.$invalid && v.$dirty
          }">
          {{ label }}
        </div>
        <div class="outline-disabled"></div>
        <v-icon class="outline-icon-right">arrow_drop_down</v-icon>
      </div>
      <v-card :class="{ 'select-custom-rows-bloco': true, 'select-custom-rows-bloco-hide': esconder }" v-show="exibirSelect" ref="selectBloco">
        <v-list>
          <v-list-item v-if="options.length <= 0">
              <v-list-item-title>Nenhum item</v-list-item-title>
          </v-list-item>
          <template v-else v-for="item in options">
            <v-list-item :key="item.id" ripple :title="item.title" @click="selecionarItem(item.value)" :class="{ 'selected': item.value === value }">
                <v-list-item-title >
                  <v-icon v-if="item.icon" style="margin-right: 15px">{{ item.icon }}</v-icon>
                  {{ item.text }}
                </v-list-item-title>
            </v-list-item>
          </template>
        </v-list>
      </v-card>
    </div>
  </Validator>
</template>

<script>
import Validator from './Valitador.vue';

export default {
  name: 'SelectCustomRows',
  components: {
    Validator,
  },
  props: {
    value: [ String, Number, Object, Array ],
    options: Array,
    label: String,
    disabled: {
      type: Boolean,
      default: false,
    },
    validation: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    v: {
      type: Object,
      default() {
        return {
          $invalid: false,
          $dirty: false,
          $touch: () => {},
        };
      },
    },
  },
  data() {
    return {
      inputFocus: false,
      exibirSelect: false,
      esconder: false,
    };
  },
  created() {
    document.addEventListener('click', this.onClickSelectEvent);
  },
  destroyed() {
    document.removeEventListener('click', this.onClickSelectEvent);
  },
  methods: {
    onClick() {
      this.$refs.input.focus();
      this.openSelect();
    },
    onClickSelectEvent(event) {
      const el = this.$refs.selectLista;
      const target = event.target;
      if ((el !== target) && !el.contains(target)) { this.closeSelect(); }
    },
    onKeyUp(e) {
      if (e.keyCode === 13) { this.openSelect(); }
      if (e.keyCode === 38) {  }
      if (e.keyCode === 40) {  }
    },
    onFocus() {
      this.inputFocus = true;
      this.$emit('focus');
    },
    onBlur() {
      this.v.$touch();
      this.inputFocus = false;
      this.$emit('blur');
    },
    onChange(e) {
      this.v.$touch();
      this.$emit('change');
    },
    openSelect() {
      if(this.disabled || this.$refs.input.disabled) { return; }
      this.exibirSelect = true;
      setTimeout(() => {
        let container = this.$refs.selectBloco.$el;
        let element = container.querySelector('.selected');
        if(element) { container.scrollTop = element.offsetTop; }
      }, 200);
    },
    closeSelect() {
      this.esconder = true;
      setTimeout(() => {
        this.esconder = false;
        this.exibirSelect = false;
      }, 300);
    },
    selecionarItem(valor) {
      if(valor !== this.value) {
        this.$emit('input', valor);
        this.$emit('change');
      }

      this.$refs.input.focus();
      this.closeSelect();
    },
  },
  computed: {
    descricaoValue() {
      const descricao = this.options.find(key => key.value === this.value);
      return (descricao) ? descricao.text : '';
    },
  },
};
</script>

<style lang="scss">
.outline-input-select {
  padding: 12px 28px 14px 16px!important;
  overflow: hidden;
}

.outline-input-disabled {
  color: #828282!important;
}

.input-custom-rows {
  position: absolute;
  &:focus {
    outline: none;
  }
}

.custom-input {
  input {
    &:disabled ~ .outline-disabled {
      background-color: #94949424;
    }
  }
}

.select-custom-rows-bloco {
  overflow: auto;
  max-height: 300px;
  min-height: 60px;
  position: absolute;
  z-index: 4;
  width: 100%;
  top: -7px;
  animation: selectshow .3s ease-out;

  .selected {
    background: rgba(0, 167, 200, 0.36);
  }
}

.select-custom-rows-bloco-hide {
  animation: selecthide .3s ease-out;
}

@keyframes selectshow {
  0%{
    transform: scale(.8);
    opacity: 0;
  }
  100%{
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes selecthide {
  0%{
    transform: scale(1);
    opacity: 1;
  }
  100%{
    transform: scale(.8);
    opacity: 0;
  }
}
</style>
